import React from 'react'
import PropTypes from 'prop-types'

import { graphql } from 'gatsby'
import styled from 'styled-components'
import decodeEntities from '../util/textDecode'
import { Breadcrumb } from './Breadcrumb'
import { device } from './Breakpoints'
import { colors } from './Colors'

const Container = styled.section`
  width: 100%;
  h1 {
    width: 1114px;
    margin: auto;
    color: #fa7373;
  }
  .center {
    max-width: 1114px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: start;
    @media ${device.mobileL} {
      max-width: 100%;
      text-align: center;
      flex-wrap: wrap;
    }
    h2 {
      text-align: left;
      margin-top: 1em;
      margin-bottom: 0.4em;

      @media ${device.mobileL} {
        text-align: center;
      }
    }
  }
  h2 {
    margin-top: 2em;
    text-align: center;
    color: ${colors.verde};
    font-size: 1.2em;
  }
  aside {
    margin: 2em 0 0;
    padding: 20px 50px;
    max-width: 300px;
    box-sizing: border-box;
    order: 2;
    h3 {
      font-size: 25px;
      color: #fa7373;
    }
    h4 {
      font-size: 20px;
    }
    p {
      font-size: 14px !important;
      line-height: 20px !important;
    }
    @media ${device.mobileL} {
      margin: 0;
      max-width: 100%;
      order: 1;
    }
  }
  ul.imprensa {
    padding: 0;
    margin: 2em 0 0;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    order: 1;
    @media ${device.mobileL} {
      margin: 2em;
      order: 2;
    }
    li {
      list-style: none;
      background: #fff;
      border: 1px solid #ebebea;
      margin-bottom: 0.5em;
      width: 100%;
      box-sizing: border-box;
      padding: 2em;
      justify-content: space-between;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      @media ${device.mobileL} {
        width: 100%;
      }
      .thumb {
        margin: -2em -2em 1.5em;
        overflow: hidden;
        max-height: 212px;
        img {
          width: 100%;
        }
      }
      small {
        font-size: 0.6em;
        padding: 0;
      }
      h3 {
        margin: 0 0 0.5em;
        display: block;
        width: 100%;
        font-size: 1.5em;
        a {
          color: ${colors.vermelho};
          text-decoration: none;
          display: block;
        }
      }
      p {
        font-size: 0.6em;
      }
    }
  }
  ul.categories {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    li {
      margin: 0 0.5em 0 0;
      border: 0;
      background: red;
      padding: 0.5em 0.8em;
      border-radius: 5px;
      width: auto;
      color: #ffffff;
      font-size: 0.6em;
    }
  }
`

const ImprensaPage = ({ imprensa, crumbs }) => {
  return (
    <Container>
      <Breadcrumb crumbs={crumbs} />
      <h1>Imprensa</h1>
      <div className="center">
        <ul className="imprensa">
          {imprensa.map(({ node: materia }) => (
            <li key={materia.id}>
              <small>{materia.Imprensa.data}</small>
              <h3>
                <a
                  href={materia.Imprensa.linkExterno}
                  target="_blank"
                  rel="noreferrer"
                >
                  {decodeEntities(materia.title)}
                </a>
              </h3>
              <div
                dangerouslySetInnerHTML={{
                  __html: materia.excerpt.replace(/<p class="link-more.*/, ''),
                }}
              />
            </li>
          ))}
        </ul>
        <aside>
          <h3>Assessoria de Imprensa</h3>
          <p>
            Prezado jornalista, entre em contato com a nossa assessoria de
            imprensa a4&holofote comunicação. Os telefones são:
          </p>
          <h4>Milena Furtado</h4>
          <p>
            <strong> Tel.:</strong> +55 11 3897-4123 <br />
            <strong>Cel.:</strong> +55 11 99930-6433
            milenafurtado@a4eholofote.com.br
          </p>
          <h4> Mariana Bertolini</h4>
          <p>
            <strong> Tel.:</strong> +55 11 3897 4133 <br />
            <strong>Cel.:</strong> +55 11 99916 8091
            marianabertolini@a4eholofote.com.br
          </p>
        </aside>
      </div>
    </Container>
  )
}

ImprensaPage.propTypes = {
  Imprensa: PropTypes.arrayOf(PropTypes.object),
}

export const ImprensaQuery = graphql`
  fragment ImprensaListFields on wordpress__wp_imprensa {
    id
    title
    date
    slug
    excerpt
    Imprensa {
      data
      linkExterno
    }
  }
`
export default ImprensaPage
